import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { fileUrl } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { Landmark } from "lucide-react";

export default function LoanProviderStrip() {
  const { feature } = useSettings();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (feature("loan_provider_strip") && feature("home_loans"))
      api.get("/loan-providers").then((r) => setItems(r.data.providers || [])).catch(() => {});
  }, [feature]);

  if (!feature("loan_provider_strip") || !feature("home_loans") || items.length === 0) return null;
  const row = [...items, ...items];

  return (
    <section className="bg-brand-emerald/5 border-y border-brand-line py-3 overflow-hidden" data-testid="loan-provider-strip">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center gap-2 mb-2">
        <Landmark className="w-4 h-4 text-brand-emerald" />
        <span className="text-xs font-semibold uppercase tracking-widest text-brand-emerald">Home Loan Partners</span>
      </div>
      <div className="relative overflow-hidden">
        <div className="flex gap-3 w-max animate-loan-marquee hover:[animation-play-state:paused]">
          {row.map((p, i) => (
            <button key={i} onClick={() => navigate("/home-loans")} data-testid={`loan-strip-card-${i}`}
              className="shrink-0 flex items-center gap-3 bg-card border border-brand-line rounded-xl px-4 py-2.5 hover:border-brand-emerald transition-colors">
              {p.logo
                ? <img src={fileUrl(p.logo)} alt={p.name} className="w-9 h-9 rounded-lg object-contain bg-white border border-brand-line" />
                : <div className="w-9 h-9 rounded-lg bg-brand-emerald/10 flex items-center justify-center"><Landmark className="w-4 h-4 text-brand-emerald" /></div>}
              <div className="text-left">
                <div className="text-sm font-semibold text-brand-ink whitespace-nowrap">{p.name}</div>
                {p.interest_rate && <div className="text-xs text-brand-emerald font-medium whitespace-nowrap">{p.interest_rate}</div>}
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
